import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  leftValue?: string;
  bottomValue?: string;
  border?: boolean;
  selected?: boolean;
}

export const Root = styled.div`
  min-width: 219px;
  width: 219px;
  margin: 5px;
  &.item-enter {
    opacity: 0;
    transform: scale(0);
  }
  &.item-enter-active {
    opacity: 1;
    transform: scale(1);
    transition: all 200ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  &.item-exit {
    opacity: 1;
    transform: scale(1);
  }
  &.item-exit-active {
    opacity: 0;
    transform: scale(0);
    transition: all 600ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
`;

export const MainContainer = styled.div`
  width: 100%;
`;

export const BoxContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
`;

export const InfoExtraContainer = styled.div`
  z-index: 50;
  position: absolute;
  top: 13px;
  right: ${(props: IRootProps) => (props.border ? '20px' : '13px')};
  display: flex;
`;

export const Sizes = styled.div`
  display: flex;
  align-items: center;
  height: 23px;
  padding: 0px 12px;
  border-radius: ${(props: IRootProps) => (props.border ? '5px 0px 0px 5px;' : '5px;')};
  margin-right: ${(props: IRootProps) => (props.border ? '1px' : '')};
  background-color: rgba(32, 64, 120, 0.66);
  font-family: Roboto;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${C.WHITE};
`;

export const Favorite = styled.div`
  display: flex;
  align-items: center;
  height: 23px;
  padding: ${(props: IRootProps) => (props.border ? '0px 8.5px;' : '0px 8px;')};
  border-radius: ${(props: IRootProps) => (props.border ? '0px 5px 5px 0px;' : '5px;')};
  background-color: rgba(32, 64, 120, 0.66);
  font-family: Roboto;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${C.WHITE};
`;

export const PreviewContainer = styled.div`
  flex: 1;
  height: 185px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.05);
  background-color: ${C.WHITE};
  cursor: pointer;
  transition: transform 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    transform: scale(1.05);
    border: ${(props: IRootProps) => (props.selected ? `1px solid ${C.DARK_ORANGE}` : `1px solid ${C.BLUE}`)};
    height: 183px;
  }
  ${BoxContainer}:hover & {
    transform: scale(1.05);
  }
  border: ${(props: IRootProps) => (props.selected ? 'solid 2px #ff7319' : '')};
  box-sizing: border-box;
`;

export const PreviewContent = styled.div`
  width: 100%;
  height: 100%;
`;

export const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const BottomContainer = styled.div`
  height: 85px;
`;

export const MetaDataContainer = styled.div`
  position: absolute;
  box-sizing: border-box;
  max-height: 140px;
  bottom: 0px;
  left: 0px;
  width: 100%;
  background-color: ${C.BLUE};
  border-radius: 0px 0px 4px 4px;
  display: none;
  ${BoxContainer}:hover & {
    display: flex;
  }
`;

export const MetaData = styled.div`
  flex: 1;
  padding: 13px 20px 15px 15px;
  position: relative;
  overflow: hidden;
`;

export const HoverMetaDataContainer = styled.div`
  position: fixed;
  left: ${(props: IRootProps) => (props.leftValue ? props.leftValue : '0px')};
  bottom: ${(props: IRootProps) => (props.bottomValue ? props.bottomValue : '-30px')};
  justify-content: center;
  z-index: 100;
  max-height: 0px;
  opacity: 0;
  transition: opacity 0.2s, max-height 0s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  ${BoxContainer}:hover & {
    opacity: 1;
    max-height: 1000px;
    transition-delay: 0.8s;
  }
`;

export const HoverMetaData = styled.div`
  box-sizing: border-box;
  padding: 18px;
  border-radius: 2px;
  width: 206px;
  background-color: rgba(18, 36, 66, 0.95);
  &:hover {
    ${MetaDataContainer} {
      display: flex;
    }
  }
`;

export const MetaDataTitle = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(255, 255, 255, 0.5);
`;

export const MetaDataCustomTags = styled.div`
  margin: 10px 0px 0px 0px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: ${C.WHITE};
`;

export const MetadataBottomGradient = styled.div`
  width: 100%;
  height: 15px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  background-image: linear-gradient(to bottom, ${C.BLUE}00, ${C.BLUE} 90%);
`

export const MetaDataOptionIconContainer = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  cursor: pointer;
`;

export const MetaDataFolder = styled.div`
`;

export const MetaDataFolderName = styled.div`
`;

export const Title = styled.div`
  margin: 11px 0px 0px 0px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${C.MID_GRAY};
`;

export const Subtitle = styled.div`
  display: flex;
  margin: 8px 0px 0px 0px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${C.MID_GRAY};
`;

export const SubtitleBold = styled.div`
  margin: 0px 0px 0px 3px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${C.MID_GRAY};
`;

export const FormatsAbsoluteContainer = styled.div`
  position: fixed;
  left: ${(props: IRootProps) => (props.leftValue ? props.leftValue : '0px')};
  bottom: ${(props: IRootProps) => (props.bottomValue ? props.bottomValue : '-30px')};
  display: flex;
  justify-content: center;
  z-index: 100;
  max-height: 0px;
  opacity: 0;
  transition: opacity 0.2s, max-height 0s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  ${Subtitle}:hover & {
    display: flex;
    opacity: 1;
    max-height: 1000px;
    transition-delay: 0.5s;
  }
`;

export const FormatsContainer = styled.div`
  margin: 1.7px 0 0;
  padding: 13px 0px 0px;
  border-radius: 2px;
  background-color: ${C.DARKEST_GRAY};
`;

export const FormatLabel = styled.div`
  padding: 0px 20px 13px 20px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARKER_WHITE};
`;